import React, { useState, useContext, useEffect } from "react"
import styled from "styled-components"
import { FaCalendar } from "@react-icons/all-files/fa/FaCalendar"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import Loader1 from "../../interceptors/loader-interceptor"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import { findCurrentJourneyCode, DataLayerIntegration, transactionDataLayer } from "../services/helperFunctions"
import { fetchApplicationDetails, sendEmailBI, saveApplication, downloadPaymentReceipt } from "../../services/apiservice" 
import { ErrorContext } from "../context/errorContext";
import {errorToastr,successToastr,clearToastr} from "../../services/error-handler"
import * as moment from "moment";
import { withPrefix } from "gatsby"
import * as lookup from "../../../static/lookup.json";
import { maskAlternateCharsInEmail } from "../../shared/functions"

export default function SuccessfulTransactions(props) {
  const[errorState, setErrorState] = useContext(ErrorContext);
  const [b64Receipt, setB64Receipt] = useState();
  const [needToDoEnach, setNeedToDoEach] = useState(false)
  console.log(errorState)
  const [localJourneyData, setLocalJourneyData] = useState({})
  useEffect(async()=>{
    let payload = {
      _id: journeyState.journeyId,
    }
    fetchApplicationDetails(payload).then(res=>{
      console.log(res);
      let transactionDetails = res?.journeyData?.transactionDetails
      if(transactionDetails && transactionDetails.transactions?.length){
        let lastTransaction = transactionDetails.transactions[transactionDetails.transactions.length -1]
        if(lastTransaction && lastTransaction.mandateOpt){
          if(lastTransaction.hasOwnProperty("mandate")){
            if(lastTransaction.mandate?.status !== "active"){
              setNeedToDoEach(true)
            }
          }else{
            setNeedToDoEach(true)
          }
        }
      }
      
      setLocalJourneyData(res);
      transactionDataLayer(res, "", props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
      getDownloadPaymentReceiptData();
    })
    .catch(err=>{
      console.error(err)
    })
  },[])

  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const date = new Date();
  const validPayDate = new Date(date.setDate(date.getDate() + 30)).toLocaleDateString();

  const handleClick = () => {
    if (journeyState.journeyIdFromStrapi === "GAINjourney"){
      if (needToDoEnach){
        let journeyFormatData = props.applicationDataInJourneyFormat()
        DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "proceedToNach", journeyState)
      }else{
        let journeyFormatData = props.applicationDataInJourneyFormat()
        DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "completeApplication", journeyState)
      }
    }else{
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "proceed", props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
    }
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: needToDoEnach ? props.currentPageIndex : props.currentPageIndex + 1,
        lastSection: needToDoEnach ? props.currentSectionIndex + 1  : 0,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        planOption: journeyState.planOption,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      }
    }
    saveApplication(sendPayload).then(res => {
      console.log(journeyState, "from successfull transcation")
      if (needToDoEnach) {
        setErrorState({})
        props.setCurrentSectionIndex(prev => prev +1) // this moves to first section of next page

        setJourneyState((prev) => {
          return ({
            ...prev,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex].sectionId)
          })
        })
      } else {
        console.log(sectionState)
        props.setCurrentPageIndex(prev => prev + 1)
        setSectionState(prev => {
          // making section data empty to load new sectionData
          return {
            ...prev,
            sectionId: null,
            sectionFirstPass: null,
            sectionData: {},
          }
        })
        setErrorState({})
        props.setCurrentSectionIndex(0) // this moves to first section of next page
        setErrorState(prev=>{
          return {
            ...prev,
            ['pincode']:"",
            ['country']:"",
          }
        })
        setErrorState(prev=>{
          return {
            ...prev,
            ['pincode']:"",
            ['country']:"",
          }
        })
        setJourneyState((prev) => {
          return ({
            ...prev,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            journeyCode: findCurrentJourneyCode(props.pageId, props.sections[props.currentSectionIndex].sectionId)
          })
        })
      }
    }).catch(err => {
      console.log(err, "err in saveApplication")
    })
  }

  const getDownloadPaymentReceiptData = async ()=>{
    const paymentTxnId = journeyState.paymentDecryptData.paymentTxnId;
    const res = await downloadPaymentReceipt(journeyState.journeyId,paymentTxnId);
    if(res.status){
      setB64Receipt(res.data)
    }else{
      errorToastr("Payment data does not exist!")
    }
  }

  const getDownloadPaymentReceiptData2 = async ()=>{
    const paymentTxnId = journeyState.paymentDecryptData.paymentTxnId;
    const res = await downloadPaymentReceipt(journeyState.journeyId,paymentTxnId);
    if(res.status){
      setB64Receipt(res.data);
      pdfDownload(res.data);
    }else{
      errorToastr("Payment data does not exist!")
    }
  }

  const downloadReceipt = () =>{
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "downloadReceipt", journeyState)
    if(b64Receipt){
      pdfDownload(b64Receipt);
    }else{
      getDownloadPaymentReceiptData2();
    }
  }

  const pdfDownload = (b64Receipt)=>{
      const downloadLink = document.createElement("a")
      downloadLink.href = `data:application/pdf;base64,${b64Receipt}`
      const fileName = `${lookup?.pdfProdutPlanName[journeyState?.journeyIdFromStrapi] ?? ""}_Receipt_${journeyState.applicationNo}.pdf`;
      downloadLink.download = fileName;
      downloadLink.click();
  }

  let emailId = localJourneyData?.journeyData?.basicDetails?.emailID
  let maskedEmail = maskAlternateCharsInEmail(emailId)

  return (
    <>
    <Loader1/>
      <style>
        {`
          .input-group.date .input-group-addon{
            background:none;
          }
    
          @media (max-width: 767px){

            .form-group {
              margin-bottom: 34px;
            }
            
          }
          .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
            margin-left:-2px;
          }
          ::-ms-clear {
            display: none;
          }    
          .d-none{
            display: none;
          }   
          .br-0{
            border-radius: 0px !important;
          }
              `}
      </style>

      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            <div className="iselect-box-design">
              <div className="iselect-padding">
                <div className="payment-receipt-structure-design">
                  <div className="payment-receipt-structure-design-healine">
                    {" "}
                    {/* <img src={withPrefix("/images/success-icon.png")} />
                    <h2>Congratulations!</h2>
                    <h3>We have received your payment</h3>
                    <div className="line"></div> */}
                    <p>
                      Please complete your entire application before {moment(localJourneyData?.journeyData?.loginDate).add(45, 'days').format("DD-MMM-YYYY")} as your premium will be marginally increased
                      after this date.
                    </p>
                  </div>
                  <div className="download-receipt-structure">
                    <div className="ap-receipt-stucture">
                      {" "}
                      <span>Application Number</span>
                      <h2>{journeyState.applicationNo}</h2>
                    </div>
                    {/* <a style={{color:"#fff", textDecoration:"none",}}>
                      <div className="download-ap-receipt-stucture">
                        {" "}
                        <img src={withPrefix("/images/download-receipt.png")} style={{cursor:"pointer"}} aria-hidden="true" onClick={downloadReceipt}/>
                        <p aria-hidden="true" onClick={downloadReceipt} style={{cursor:"pointer"}}>
                          Click to
                          <br />
                          Download Receipt
                        </p>
                      </div>
                    </a>{" "} */}
                  </div>
                  <div className="clearfix"></div>
                  <div className="emil-structure">
                    {/* <p>
                      Payment Receipt has also been sent to your registered
                      email ID <strong>{maskedEmail}</strong>
                    </p> */}
                    <p>
                      You are only a few minutes away from completing your
                      application. Please click on Proceed to continue with your application.
                    </p>
                  </div>
                </div>

                <div className="iselect-mg-bottom hidden-desktop-screen">
                  <div className="col-md-12">
                    <div className="but-center text-center">
                      <div className="previous-btn cen" style={{padding:"0px"}}>
                        <a  style={{padding:"0px"}}>
                          {" "}
                          <button
                            type="submit"
                            value="button2"
                            name="button2"
                            style={{backgroundColor:"transparent", padding:"14px 40px", border:"none", borderRadius:"10px", color:"#fff"}}
                            onClick={handleClick}
                          >
                            {needToDoEnach ? "Proceed" : "Complete Application"}
                          </button>{" "}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
        <div className="iselect-mg-bottom">
          <div className="col-md-12">
            <div className="but-center text-center">
              <div className="previous-btn cen" style={{width:"auto",padding:"0",lineHeight:"50px"}}>
                <a aria-hidden="true" onClick={handleClick}>
                  {" "}
                  <button
                    type="submit"
                    value="button2"
                    name="button2"
                    style={{backgroundColor:"transparent", padding:"0px 10px", border:"none", color:"#fff",width:"initial",margin:"0"}}
                  >
                    {needToDoEnach ? "Proceed" : "Complete Application"}
                  </button>{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
